import React, { useState, useEffect } from "react";
import axios from "axios";
import colors from "../Constants/colors"; // using your dashboard color scheme

function TestSchedule() {
  const [testSchedules, setTestSchedules] = useState([]);
  const [form, setForm] = useState({
    testName: "",
    subject: "",
    class: "",
    section: "",
    date: "",
    startTime: "",
    endTime: "",
    invigilator: "",
    roomNumber: "",
    additionalNotes: "",
  });
  const [editingId, setEditingId] = useState(null);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [teacher, setTeacher] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const labelStyle = "text-black font-semibold mb-1 !text-[18px]";
  const inputStyle =
    "border rounded-lg px-3 py-2 outline-none !text-[14px] placeholder:!text-[14px] focus:ring-2 focus:ring-blue-500";

useEffect(() => {
  const fetchTeacherAndData = async () => {
    try {
      const teacherRaw = localStorage.getItem("teacher");
      const sessionId = localStorage.getItem("currentSessionId");

      if (!teacherRaw || !sessionId) {
        console.error("Missing teacher or session info.");
        return;
      }

      const teacherData = JSON.parse(teacherRaw);
      const teacherId = teacherData.id;

      if (!teacherId) {
        console.error("Teacher ID not found.");
        return;
      }

      // Fetch teacher info
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${teacherId}`,
        { params: { sessionId } } // send sessionId as query param
      );

      setTeacher(res.data);
      const { firstName, lastName } = res.data;

      // Fetch classes based on teacher name
      fetchClasses(`${firstName} ${lastName}`);

      // Fetch test schedules
      fetchTestSchedules();

    } catch (err) {
      console.error("Error fetching teacher info:", err.response?.data || err.message);
    }
  };

  fetchTeacherAndData();
}, []);
const sessionId = localStorage.getItem("currentSessionId");

  const fetchClasses = async (teacherName) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getTeacherClasses/${teacherName}`,
        { params: { sessionId } }
      );
      setClasses(res.data);
    } catch (err) {
      console.error("Error fetching classes:", err);
    }
  };

  const fetchTestSchedules = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/testSchedules/getTestSchedules`,
        { params: { sessionId } }
      );
      setTestSchedules(res.data);
    } catch (err) {
      console.error("Error fetching schedules:", err);
    }
  };

  const fetchSubjects = async (className) => {
    if (!teacher) return;
    try {
      const { firstName, lastName } = teacher;
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getSubjectsByTeacherAndClass/${firstName}%20${lastName}/${className}`,
        { params: { sessionId } }
      );
      setSubjects(Array.isArray(res.data.subjects) ? res.data.subjects : []);
    } catch (err) {
      console.error("Error fetching subjects:", err);
    }
  };

  useEffect(() => {
    if (form.class) fetchSubjects(form.class);
  }, [form.class]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
   if (name === "class") {
  if (!value) {
    // if no class selected, clear both
    setForm({ ...form, class: "", section: "" });
  } else {
    const [cls, sec] = value.split("|");
    setForm({ ...form, class: cls, section: sec || "" }); // make sure section is not undefined
  }
} else {
  setForm({ ...form, [name]: value });
}

  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);

  const sessionId = localStorage.getItem("currentSessionId");
  if (!sessionId) {
    console.error("Missing sessionId");
    setIsLoading(false);
    return;
  }


  // Map form fields to backend expected fields
const payload = {
  sessionId,
  testName: form.testName,
  subject: form.subject,
  class: form.class,    // send as "class"
  section: form.section, // send as "section"
  date: form.date,
  startTime: form.startTime,
  endTime: form.endTime,
  invigilator: form.invigilator,
  roomNumber: form.roomNumber,
  additionalNotes: form.additionalNotes || "",
};

for (const [key, value] of Object.entries(payload)) {
  if (!value) {
    alert(`Field ${key} is required`);
    setIsLoading(false);
    return;
  }
}
  // Optional: simple validation
  for (const [key, value] of Object.entries(payload)) {
    if (!value) {
      alert(`Field ${key} is required`);
      setIsLoading(false);
      return;
    }
  }

  try {
    if (editingId) {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/testSchedules/updateTestSchedule/${editingId}`,
        payload
      );
      alert("Updated successfully!");
    } else {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/testSchedules/createTestSchedule`,
        payload
      );
      alert("Created successfully!");
    }

    setForm({
      testName: "",
      subject: "",
      class: "",
      section: "",
      date: "",
      startTime: "",
      endTime: "",
      invigilator: "",
      roomNumber: "",
      additionalNotes: "",
    });
    setEditingId(null);
    fetchTestSchedules();
  } catch (err) {
    console.error("Error saving schedule:", err.response?.data || err.message);
  } finally {
    setIsLoading(false);
  }
};



  const handleEdit = (item) => {
    setForm({
      testName: item.testName || "",
      subject: item.subject || "",
      class: item.class || "",
      section: item.section || "",
      date: item.date ? item.date.split("T")[0] : "",
      startTime: item.startTime || "",
      endTime: item.endTime || "",
      invigilator: item.invigilator || "",
      roomNumber: item.roomNumber || "",
      additionalNotes: item.additionalNotes || "",
    });
    setEditingId(item._id);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this schedule?")) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_BASE_URL}/api/testSchedules/deleteTestSchedule/${id}`,
          { params: { sessionId } }
        );
        fetchTestSchedules();
      } catch (err) {
        console.error("Error deleting schedule:", err);
      }
    }
  };

  const getFiltered = () => {
  // 🚫 Do not show anything until class & subject are selected
  if (!form.class || !form.subject) return [];

  return testSchedules.filter(
    (s) =>
      s.class === form.class &&
      s.section === form.section &&
      s.subject === form.subject
  );
};


  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <i className="fas fa-clipboard-list text-blue-600 !text-[20px]" />
          <h1 className="font-bold !text-[18px]">Test Schedule</h1>
        </div>
        {editingId && (
          <span className="text-sm text-gray-500">
            Editing schedule – <span className="font-semibold">Update mode</span>
          </span>
        )}
      </div>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="space-y-6 mb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Test Name */}
          <div className="flex flex-col">
            <label className={labelStyle}>Test Name:</label>
            <input
              type="text"
              name="testName"
              value={form.testName}
              onChange={handleInputChange}
              placeholder="Enter test name"
              className={inputStyle}
              required
            />
          </div>

          {/* Class */}
          <div className="flex flex-col">
            <label className={labelStyle}>Class:</label>
            <select
              name="class"
              value={form.class && form.section ? `${form.class}|${form.section}` : ""}
              onChange={handleInputChange}
              className={inputStyle}
              required
            >
              <option value="">Select Class</option>
              {classes.map((cls) => (
                <option
                  key={cls._id}
                  value={`${cls.className}|${cls.sectionName}`}
                >
                  {cls.className} ({cls.sectionName})
                </option>
              ))}
            </select>
          </div>

          {/* Subject */}
          <div className="flex flex-col">
            <label className={labelStyle}>Subject:</label>
            <select
              name="subject"
              value={form.subject}
              onChange={handleInputChange}
              className={inputStyle}
              required
            >
              <option value="">Select Subject</option>
              {subjects.map((sub, i) => (
                <option key={i} value={sub}>
                  {sub}
                </option>
              ))}
            </select>
          </div>

          {/* Date */}
          <div className="flex flex-col">
            <label className={labelStyle}>Date:</label>
            <input
              type="date"
              name="date"
              value={form.date}
              onChange={handleInputChange}
              className={inputStyle}
              required
            />
          </div>

          {/* Start Time */}
          <div className="flex flex-col">
            <label className={labelStyle}>Start Time:</label>
            <input
              type="time"
              name="startTime"
              value={form.startTime}
              onChange={handleInputChange}
              className={inputStyle}
              required
            />
          </div>

          {/* End Time */}
          <div className="flex flex-col">
            <label className={labelStyle}>End Time:</label>
            <input
              type="time"
              name="endTime"
              value={form.endTime}
              onChange={handleInputChange}
              className={inputStyle}
              required
            />
          </div>

          {/* Invigilator */}
          <div className="flex flex-col">
            <label className={labelStyle}>Invigilator:</label>
            <input
              type="text"
              name="invigilator"
              value={form.invigilator}
              onChange={handleInputChange}
              placeholder="Enter invigilator name"
              className={inputStyle}
              required
            />
          </div>

          {/* Room Number */}
          <div className="flex flex-col">
            <label className={labelStyle}>Room Number:</label>
            <input
              type="text"
              name="roomNumber"
              value={form.roomNumber}
              onChange={handleInputChange}
              placeholder="Enter room number"
              className={inputStyle}
              required
            />
          </div>

          {/* Additional Notes */}
          <div className="flex flex-col md:col-span-2">
            <label className={labelStyle}>Additional Notes:</label>
            <textarea
              name="additionalNotes"
              value={form.additionalNotes}
              onChange={handleInputChange}
              placeholder="Enter any additional information (optional)"
              className={`${inputStyle} min-h-[80px] resize-y`}
            />
          </div>
        </div>

        {/* ACTION BUTTONS */}
        <div className="flex justify-start gap-4 mt-4">
          <button
            type="submit"
            disabled={isLoading}
            className="text-white px-4 py-2 rounded-lg !text-[14px] hover:scale-[1.02] transition-transform"
            style={{ background: colors.gradientPrimary }}
          >
            {isLoading
              ? "Saving..."
              : editingId
              ? "Update Schedule"
              : "Add Schedule"}
          </button>

          {editingId && (
            <button
              type="button"
              onClick={() => {
                setEditingId(null);
                setForm({
                  testName: "",
                  subject: "",
                  class: "",
                  section: "",
                  date: "",
                  startTime: "",
                  endTime: "",
                  invigilator: "",
                  roomNumber: "",
                  additionalNotes: "",
                });
              }}
              className="bg-red-600 hover:bg-red-500 text-white px-4 py-2 rounded-lg !text-[14px]"
            >
              Cancel
            </button>
          )}
        </div>
      </form>

      {/* TABLE CARD */}
      <div className="bg-white shadow-lg rounded-lg p-6">
        <h2 className="font-semibold mb-4 flex items-center gap-2 !text-[18px] text-gray-900">
          <i className="fas fa-table text-blue-500 !text-[18px]" />
          Test Schedules
        </h2>

        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300 text-center !text-[14px]">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                {[
                  "#",
                  "Test",
                  "Class",
                  "Subject",
                  "Date",
                  "Timing",
                  "Invigilator",
                  "Room",
                  "Actions",
                ].map((h) => (
                  <th key={h} className="px-4 py-2 border font-semibold">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white">
              {getFiltered().length ? (
                getFiltered().map((s, i) => (
                  <tr
                    key={s._id}
                    className="hover:bg-gray-50 border-b transition-colors"
                  >
                    <td className="px-4 py-2 border">{i + 1}</td>
                    <td className="px-4 py-2 border">{s.testName}</td>
                    <td className="px-4 py-2 border">
                      {s.class} ({s.section})
                    </td>
                    <td className="px-4 py-2 border">{s.subject}</td>
                    <td className="px-4 py-2 border">
                      {new Date(s.date).toLocaleDateString()}
                    </td>
                    <td className="px-4 py-2 border">
                      {s.startTime} - {s.endTime}
                    </td>
                    <td className="px-4 py-2 border">{s.invigilator}</td>
                    <td className="px-4 py-2 border">{s.roomNumber}</td>
                    <td className="px-4 py-2 border">
                      <div className="flex justify-center gap-3">
                        <button
                          onClick={() => handleEdit(s)}
                          className="text-yellow-600 hover:underline"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(s._id)}
                          className="text-red-600 hover:underline"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="9"
                    className="py-3 text-gray-500 text-center border"
                  >
                    No schedules found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default TestSchedule;
